import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;
  overflow: hidden;
`;
